import { render, staticRenderFns } from "./OutfitImage.vue?vue&type=template&id=f4f65080&scoped=true"
import script from "./OutfitImage.vue?vue&type=script&lang=js"
export * from "./OutfitImage.vue?vue&type=script&lang=js"
import style0 from "./OutfitImage.vue?vue&type=style&index=0&id=f4f65080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f65080",
  null
  
)

export default component.exports